import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AddressType, DirectoryAddressModel } from '../symbols';

@Injectable()
export class DirectoryAddressService {
  readonly api = '/api/directory-address';

  constructor(private http: HttpClient) {
  }

  getDirectoryAddress(searchText: string, type: AddressType): Observable<DirectoryAddressModel[]> {
    return this.http.get<DirectoryAddressModel[]>(`${this.api}`, { params: { searchText, type } });
  }
}
